<div class="container" [innerHtml]="params.text | safe"></div>
